import { CHAT_TYPES } from 'helper/const';

export const clientPermission = {
  isClient: true,
  tabLabels: ['Department', 'Individual'],
  internalType: CHAT_TYPES.CLIENT_DEPARTMENT,
  showDepartmentAtIndividual: true,
};
